import httpService from "./httpService";

const apiService = {

     // logIn
     logIn(data){
        return httpService.post('login',data)
    },
    
    // createAnnouncement
    createAnnouncement(data){
        return httpService.post('news/createnews',data)
    },

     // updateAnnouncement
     updateAnnouncement(data){
        return httpService.post('news/updatenews',data)
    },

    // getAnnouncement
    getAnnouncement(){
        return httpService.get('news');
    },

    // getFeedback
    getFeedback(){
        return httpService.get('feedback');
    },

    // getAppVersionSettings
    getAppVersionSettings(){
        return httpService.get('admin/app-version');
    },

    // updateAppVersionSettings
    updateAppVersionSettings(data){
        return httpService.put('admin/app-version', data);
    }
}

export default apiService;